module.exports = __webpack_public_path__ + "static/media/Rubik-Light.c707e69b.woff";